import { $, Backbone } from "js/vendor";
import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";

export const UndoRedo = Backbone.View.extend({
    className: "undo-redo",
    render: function() {
        let $undo = this.$el.addEl($.div("undo-button"));
        $undo.addEl($.icon("undo"));
        $undo.on("click", () => {
            ds.selection.element = null;
            app.undoManager.undo();
        });

        let $redo = this.$el.addEl($.div("undo-button"));
        $redo.addEl($.icon("redo"));
        $redo.on("click", () => {
            ds.selection.element = null;
            app.undoManager.redo();
        });

        let updateUndoRedo = function() {
            $undo.opacity(app.undoManager.stackPosition == -1 ? 0.3 : 1);
            $redo.opacity(app.undoManager.stackPosition == (app.undoManager.undoStack.length - 1) ? 0.3 : 1);
        };
        this.listenTo(app.undoManager, "undo redo undoStackChanged", () => {
            updateUndoRedo();
        });
        updateUndoRedo();
        return this.$el;
    }
});
